import React from "react";
import { useRef } from "react";
import { useState } from "react";
import useRegistrationContext from "../../../../hooks/useRegistrationContext";

const ProfilePictureLoader = ({ name }) => {
	const fileInput = useRef(null);

	const { setData } = useRegistrationContext();

	const [image, setImage] = useState(null);
	const [previewUrl, setPreviewUrl] = useState("");

	const handleOndragOver = (event) => {
		event.preventDefault();
	};
	const handleOndrop = (event) => {
		//prevent the browser from opening the image
		event.preventDefault();
		event.stopPropagation();

		//let's grab the image file
		let imageFile = event.dataTransfer.files[0];
		setImage(imageFile);
		setPreviewUrl(URL.createObjectURL(imageFile));
		setData((prevData) => ({
			...prevData,
			[name]: imageFile,
		}));
	};

	const handleInputFile = (file) => {
		//you can carry out any file validations here...
		setImage(file);
		setPreviewUrl(URL.createObjectURL(file));
		setData((prevData) => ({
			...prevData,
			[name]: file,
		}));
	};

	// URL.revokeObjectURL(previewUrl)

	return (
		<>
			<div className="col-sm-4">
				<div
					style={{
						backgroundColor: "#F3F6F9",
					}}
					className="drop_zone"
					onDragOver={handleOndragOver}
					onDrop={handleOndrop}
					onClick={() => fileInput.current.click()}
				>
					<p style={{ fontSize: 16 }}>
						Click or Drag and drop photo here....
					</p>
				</div>
			</div>
			
			<div className="col-sm-6">
				{previewUrl && (
					<div className="picture-frame">
						<div className="passport-photo">
							<img src={previewUrl} alt="image1" />
							<span> {image.name} </span>
						</div>
					</div>
				)}
			</div>
			<input
				ref={fileInput}
				hidden={true}
				id="photo"
				type="file"
				style={{ display: "none" }}
				name="personalProfilePicture"
				className="form-control"
				autoComplete="off"
				accept="image/*"
				onChange={(e) => handleInputFile(e.target.files[0])}
			/>
		</>
	);
};
export default ProfilePictureLoader;
